
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFBE1B","d":"M100 0c55.23 0 100 44.77 100 100s-44.77 100-100 100S0 155.23 0 100 44.77 0 100 0z"}}),_c('path',{attrs:{"fill":"#BEBEBE","stroke":"#707070","stroke-width":"2.257","d":"M135.28 148.47c0 1.87-1.52 3.39-3.39 3.39H61.02c-1.87 0-3.39-1.52-3.39-3.39V52.58c0-1.87 1.52-3.39 3.39-3.39h53.95l20.32 20.32v78.96z"}}),_c('path',{attrs:{"fill":"#707070","stroke":"#707070","stroke-width":"2.257","d":"M135.28 69.51h-17.07a3.25 3.25 0 01-3.25-3.25V49.19"}}),_c('g',{attrs:{"fill":"#707070"}},[_c('path',{attrs:{"d":"M56.204 63.6h44.81c3.37 0 6.1 2.73 6.1 6.1v17.66c0 3.37-2.73 6.1-6.1 6.1h-44.81c-3.37 0-6.1-2.73-6.1-6.1V69.69a6.103 6.103 0 016.1-6.09z"}}),_c('path',{attrs:{"stroke":"#707070","stroke-width":"3.048","d":"M56.204 65.12h44.81c2.53 0 4.57 2.05 4.57 4.57v17.66c0 2.53-2.05 4.57-4.57 4.57h-44.81c-2.53 0-4.57-2.05-4.57-4.57V69.69c0-2.52 2.05-4.57 4.57-4.57z"}})]),_c('path',{attrs:{"fill":"none","stroke":"#707070","stroke-width":"14.691","stroke-linecap":"square","stroke-miterlimit":"10","d":"M134.47 94.37v14.69"}}),_c('path',{attrs:{"fill":"#707070","d":"M148.75 109.06h-28.8a3.887 3.887 0 000 5.5l11.65 11.65a3.887 3.887 0 005.5 0l11.65-11.65a3.887 3.887 0 000-5.5z"}}),_c('text',{attrs:{"transform":"translate(54.093 88.114)","fill":"#FFF","font-family":"'ArialMT'","font-size":"24.517"}},[_v('PDF')])])
          )
        }
      }
    